<template>
	<div
		class="close_button"
		:class='type'
	>
		<div class="inner">
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M2.41579 23.9262L0.082489 21.5929L9.41579 12.2596L0.082489 2.92616L2.41579 0.592865L11.7492 9.92616L21.0825 0.592865L23.4158 2.92616L14.0825 12.2596L23.4158 21.5929L21.0825 23.9262L11.7492 14.5929L2.41579 23.9262Z"
					fill="#211752"
				/>
			</svg>

		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		type: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.close_button {
	width: 24px;
	height: 24px;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: 0.2s ease all;

	/* &.grey {
		.inner {
			background: var(--dark-charcoal);
		}
	} */

	@media (max-width: $mobile-xl) {
		width: 24px;
		height: 24px;
	}

	.inner {
		/* border: var(--border); */
		width: 24px;
		height: 24px;
		/* border-radius: 50%;
		background: var(--bright-blue);
		transition: 0.2s ease all; */
		display: flex;
		justify-content: center;
		align-items: center;

		&:hover {
			/* width: 32px;
			height: 32px;
			transition: 0.2s ease all; */
			cursor: pointer;
		}

		img {
			width: 18px;
			height: 18px;
		}
	}
}
</style>
